(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var showMoreBtns = document.querySelectorAll('.show-more-tags-btn');

  showMoreBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tagsList = btn.closest('.tags-block').querySelector('.tags-list');
      tagsList.classList.toggle('show-all');

      if (tagsList.classList.contains('show-all')) {
        btn.textContent = 'Show Less';
      } else {
        btn.textContent = 'More Tags (' + tagsList.querySelectorAll('.tag-hidden').length + ')';
        btn.closest('.tags-block').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
